/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            src: '',
            errored: false,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { src } = this.props;
        this.setState({ src });
    };

    onError = () => {
        const { fallbackSrc } = this.props;
        const { errored } = this.state;

        const errorImage = fallbackSrc
            || `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">'
                + '<path fill="#CCC" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>'
                + '</svg>')}`;
        if (!errored) {
            this.setState({
                src: errorImage,
                errored: true,
            });
        }
    };

    render() {
        const { src } = this.state;
        const { src: _1, fallbackSrc: _2, ...props } = this.props;

        // eslint-disable-next-line jsx-a11y/alt-text
        return <img src={src} onError={this.onError} {...props} />; // eslint-disable-line react/jsx-props-no-spreading
    }
}

Image.defaultProps = {
    fallbackSrc: '',
};

Image.propTypes = {
    src: PropTypes.string.isRequired,
    fallbackSrc: PropTypes.string,
};

export default Image;
